import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const localesSelector = (state) => resolveProp('market.locales', state);

export default createSelector(localesSelector, (locales = []) => locales);
